import { useEffect, useRef, useState } from 'react';

/**
 * Hook per gestire il ridimensionamento automatico dei titoli nelle card
 * Riduce progressivamente la dimensione del font per adattare testi lunghi
 */
export const useAdaptiveTitle = (title, maxHeight = 40) => {
  const titleRef = useRef(null);
  const [sizeClass, setSizeClass] = useState('');
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    if (!titleRef.current || !title) return;

    const element = titleRef.current;
    const container = element.parentElement;
    
    // Reset classes per rimisurazione
    setSizeClass('');
    setIsScrollable(false);
    
    // Usa setTimeout per permettere al DOM di aggiornarsi
    setTimeout(() => {
      if (!element || !container) return;
      
      const containerHeight = container.clientHeight || maxHeight;
      const originalScrollHeight = element.scrollHeight;
      
      // Se il testo sta già nell'altezza disponibile, non fare nulla
      if (originalScrollHeight <= containerHeight) {
        return;
      }
      
      // Prova dimensioni progressivamente più piccole
      const sizeClasses = ['size-sm', 'size-xs', 'size-xxs'];
      let found = false;
      
      for (const sizeClass of sizeClasses) {
        element.className = `adaptive-title ${sizeClass}`;
        
        // Force reflow
        element.offsetHeight;
        
        if (element.scrollHeight <= containerHeight) {
          setSizeClass(sizeClass);
          found = true;
          break;
        }
      }
      
      // Se anche con la dimensione più piccola non entra, abilita scroll
      if (!found) {
        setSizeClass('size-xxs');
        setIsScrollable(true);
      }
    }, 10);
  }, [title, maxHeight]);

  return {
    titleRef,
    sizeClass,
    isScrollable,
    titleClassName: `adaptive-title ${sizeClass}`.trim(),
    containerClassName: `title-container ${isScrollable ? 'scrollable' : ''}`.trim()
  };
};
